export const Login = "/login";
export const list_management = "/listManagement";
export const clue_reminder = "/clueReminder";
export const personal_center = "/personalCenter";
export const list_management_upload = "/listManagement/upload";
export const Home = "/";
export const asa_report = "/asaReport";
export const income_center = "/incomeCenter";
export const contract_subject_blank = "/contract-subject-blank";
export const mobile_personal_center = "/m/personalCenter";
export const mobile_list_management = "/m/listManagement";
export const mobile_income_center = "/m/incomeCenter";
